import { branding } from 'app/branding';

export const Header = () => {
  return branding.header;
};
